import type { ReactNode } from 'react'

import { DropdownMenu, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { useSidebar } from '@/components/ui/sidebar'
import { SidebarOrgSwitcherContent } from './sidebar-org-switcher-content.molecule'
import { formatPlanDisplay } from './sidebar-org-switcher-helpers.util'
import { SidebarOrgSwitcherTrigger } from './sidebar-org-switcher-trigger.atom'

interface Organization {
  id: string
  name: string
  slug: string | null
  imageUrl: string | null
}

interface PlanInfo {
  planName: string | null
  status: string | null
  earlyAccess?: boolean
}

interface SidebarOrgSwitcherProps {
  activeOrganization: Organization | null
  organizations: Organization[]
  onOrganizationSelect: (orgId: string) => void
  onCreateOrganization: () => void
  planInfo?: PlanInfo | null
}

export const SidebarOrgSwitcher = ({
  activeOrganization,
  organizations,
  onOrganizationSelect,
  onCreateOrganization,
  planInfo,
}: SidebarOrgSwitcherProps): ReactNode => {
  const { isMobile } = useSidebar()
  const planDisplay = formatPlanDisplay(planInfo)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <SidebarOrgSwitcherTrigger
          activeOrganization={activeOrganization}
          planDisplay={planDisplay}
        />
      </DropdownMenuTrigger>
      <SidebarOrgSwitcherContent
        organizations={organizations}
        isMobile={isMobile}
        onOrganizationSelect={onOrganizationSelect}
        onCreateOrganization={onCreateOrganization}
      />
    </DropdownMenu>
  )
}
